import type { Namespace } from "@/i18n/types";
import nsVersionEN from "./en";
import nsVersionJA from "./ja";

export const nsVersion = {
  name: "version",
  locales: {
    ja: nsVersionJA,
    en: nsVersionEN,
  },
} satisfies Namespace<"version", typeof nsVersionJA>;
